import React from 'react';

const PlayerDisplay = ({ striker, nonStriker, bowler, onChangeClick }) => {
    return (
        <>
            <div className="player-info">On Strike: <strong>{striker?.player_name}</strong><button className="change-player-btn" onClick={() => onChangeClick('Striker')}>Change</button></div>
            <div className="player-info">Non-Striker: <strong>{nonStriker?.player_name}</strong><button className="change-player-btn" onClick={() => onChangeClick('Non-Striker')}>Change</button></div>
            <hr className="my-3"/>
            <div className="player-info">Bowler: <strong>{bowler?.player_name}</strong><button className="change-player-btn" onClick={() => onChangeClick('Bowler')}>Change</button></div>
        </>
    );
};

export default PlayerDisplay;
